import { useRoleService } from "./use-role-service";

export class AuthService{
    public readonly useRole = useRoleService;
}

export const authService: AuthService = new AuthService();